export default __webpack_public_path__ + "static/media/049-geological.f9072506.svg";